import { render } from "./TelegramView.vue?vue&type=template&id=5fcf4082&scoped=true"
import script from "./TelegramView.vue?vue&type=script&lang=js"
export * from "./TelegramView.vue?vue&type=script&lang=js"

import "./TelegramView.vue?vue&type=style&index=0&id=5fcf4082&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fcf4082"]])

export default __exports__